import { applyMiddleware, createStore as createReduxStore } from 'redux';
import { middleware as createRouterMiddleware } from '@okapi/router-connect';
import { createMiddleware as createCookieMiddleware } from 'isomorphic-redux-cookie-middleware';
import { GlobalRouter } from '@okapi/router-react';
import { composeWithDevTools } from '@redux-devtools/extension';
import createSagaMiddleware, { END } from 'redux-saga';
import { RootState } from 'typesafe-actions';
import { Env, rootReducer } from './root-reducer';
import { Layers } from './header-middleware/types';
import { ReturnValueDeviceType } from 'entries/server/utils';

export type CreateStoreParams = {
  router: GlobalRouter;
  host?: string;
  url?: string;
  cookie: string;
  layers: Layers;
  preloadedState?: RootState | Record<string, unknown>;
  uuid?: string;
  isBot?: boolean;
  userAgent: string;
  deviceType: ReturnValueDeviceType;
  env: Env;
};

export function createStore({
  router,
  host = window.location.host,
  preloadedState,
  isBot = false,
  uuid,
  env,
  userAgent,
  deviceType,
  cookie,
  layers,
}: CreateStoreParams) {
  const sagaMiddleware = createSagaMiddleware();
  const cookieMiddleware = createCookieMiddleware();
  const routerMiddleware = createRouterMiddleware(router);
  const composeEnchancers = composeWithDevTools({ trace: true, traceLimit: 25 });

  const store = createReduxStore(
    rootReducer({ host, globalRouter: router, isBot, env, deviceType, userAgent, cookie, layers, uuid }),
    preloadedState,
    composeEnchancers(applyMiddleware(routerMiddleware, cookieMiddleware, sagaMiddleware)),
  );

  return {
    store,
    runSaga: sagaMiddleware.run,
    close: () => store.dispatch(END),
  };
}
